import React from "react";
import { CgSpinnerTwoAlt } from "react-icons/cg";
import "./spinner.css";

function Spinner() {
  return (
    <div className="loading" id="spinner">
      <CgSpinnerTwoAlt size={40} color="gray" />
    </div>
  );
}

export default Spinner;
